import React, { Component } from 'react'
import { StatusAlertService } from 'react-status-alert'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import TaskLogListUI from './TaskLogListUI.js'

class TaskLogListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      taskLogList: null,
    }
    this.taskId = this.props.task.taskId // used to avoid multiple fetches in componentWillReceiveProps
    this.refreshTaskLogs = null // when user clicks refresh, capture the value
  }

  render() {
    return (
      <TaskLogListUI
        context={this.props.context}
        messageList={this.props.messageList}
        taskLogList={this.state.taskLogList}
        onTaskLogListUpdate={this.onTaskLogListUpdate}
        onForceTaskListRefresh={this.props.onForceTaskListRefresh}
        onForceTaskLogListRefresh={this.onForceTaskLogListRefresh}
        projectUserMap={this.props.projectUserMap}
        project={this.props.project}
        task={this.props.task}
      />
    )
  }

  UNSAFE_componentWillMount() {
    let context = this.props.context
    this.getTaskLogs(context, this.props.task.taskId)
  }

  componentDidMount() {
    document.body.addEventListener('taskLogList', this.addTaskLogList, true)
  }

  componentWillUnmount() {
    document.body.removeEventListener('taskLogList', this.addTaskLogList, true)
  }

  addTaskLogList = (event) => {
    console.log(event.detail);
    let taskLogList = this.state.taskLogList.concat(event.detail)
    this.setState({taskLogList: taskLogList})
    CacheManager.removeObject(CacheKeys.TaskLogs(this.taskId))
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.task && props.task.taskId !== this.taskId) {
      this.taskId = props.task.taskId
      this.getTaskLogs(props.context, props.task.taskId)
    }
    else if (props.refreshTaskLogs && props.refreshTaskLogs !== this.refreshTaskLogs) {
      this.refreshTaskLogs = props.refreshTaskLogs
      this.setState({taskLogList: null})
      CacheManager.removeObject(CacheKeys.TaskLogs(this.taskId))
      this.getTaskLogs(props.context, this.taskId)
    }
  }

  getTaskLogs(context, taskId) {
    let cacheManager = new CacheManager({
      resource: `/api/tasks/${taskId}/logs`,
      cacheKey: CacheKeys.TaskLogs(taskId),
      callback: this.getTaskLogsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getTaskLogsCallback = (response) => {
    this.setState({taskLogList: response.taskLogList})
    if (response.errorList.length > 0) {
      this.handleError(response.errorList)
      return
    }
  }

  onForceTaskLogListRefresh = (taskId) => {
    CacheManager.removeObject(CacheKeys.TaskLogs(taskId))
    this.setState({taskLogList: null}, this.getTaskLogs(this.props.context, taskId))
  }

  handleError(errorList) {
    errorList.forEach(error => {
      if (error.errorCode === 'NotFound') {
        switch (error.objectCode) {
          case 'Task':
            this.props.onForceTaskListRefresh(this.props.task.projectId)
            break
          default:
        }
      }
    })
    StatusAlertService.showError(errorList[0].message, {withCloseIcon: false})
  }

  onTaskLogListUpdate = taskLogList => {
    this.setState({taskLogList: taskLogList})
  }
}

export default TaskLogListSF
